export function AuditFailureCategories() {
    return ['A', 'B', 'C'];
}
